
import apiClient from '@/services/apiService'

class CheckExamRestrictionService {
  async check(params: { exam_id?: number; exam_localization_id?: number }) {
    return apiClient.get('/exam-restriction/check', {
      params,
    })
  }
}

export default new CheckExamRestrictionService()
